import { render, staticRenderFns } from "./ProdutosOpcionaisItens.vue?vue&type=template&id=2451b524&scoped=true"
import script from "./ProdutosOpcionaisItens.vue?vue&type=script&lang=js"
export * from "./ProdutosOpcionaisItens.vue?vue&type=script&lang=js"
import style0 from "./ProdutosOpcionaisItens.vue?vue&type=style&index=0&id=2451b524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451b524",
  null
  
)

export default component.exports